import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios'

import { CustomerDetailsContext } from '../AppContext'

const EnterDetails = () => {

  const [ customerName, setCustomerName, customerEmail, setCustomerEmail, setBasketOpen, setDetailsEntered, selectedProduct, numberOfChildren, setNumberOfChildren ] = useContext(CustomerDetailsContext)

  const [isValidEmail, setIsValidEmail] = useState(true)
  const [nameEntered, setNameEntered] = useState(true)
  const [continueClicked, setContinueClicked] = useState(false)
  const [isFirstRender, setIsFirstRender] = useState(true)
  const [customerRepeatEmail, setCustomerRepeatEmail] = useState('')
  const [isMatchingEmail, setIsMatchingEmail] = useState(true)
  const [isValidNumberOfChildren, setIsValidNumberOfChildren] = useState(true)
  const [timeslotClash, setTimeslotClash] = useState(false)

  const emailRegex = /\S+@\S+\.\S+/

  const validationCheck = async () => {
    const lockedTimeslotsPromise = axios.get('https://little-munchkin-photography.herokuapp.com/api/Timeslots/locked-or-booked')

    const complete = await Promise.resolve(lockedTimeslotsPromise)
    checkForClash(complete)
  }

  const continueToPayment = async () => {
    setIsValidEmail(emailRegex.test(customerEmail))
    setIsMatchingEmail(customerEmail === customerRepeatEmail)
    setNameEntered(customerName.length > 0)
    setIsValidNumberOfChildren(numberOfChildren === '1' || numberOfChildren === '2' || numberOfChildren === '3' || numberOfChildren === '4')
    validationCheck()
  }

  const lockTimeslot = async () => {
    let now = new Date()
    let addFifteen = new Date(now)

    addFifteen.setMinutes(now.getMinutes() + 15)

    const lockDetails = {
      id: selectedProduct._id,
      time: addFifteen
    }
    
    axios.post('https://little-munchkin-photography.herokuapp.com/api/timeslots/lock', lockDetails)
  }

  const isClash = async () => {
    if (!timeslotClash) {
      setContinueClicked(!continueClicked)
    } else {
      setContinueClicked(!continueClicked)
    }
  }

  const checkForClash = async (props) => {
    if (props.data.response) {
      props.data.response.forEach((timeslot) => {
        if (timeslot._id === selectedProduct._id) {
          setTimeslotClash(true)
        }
      })
      isClash()
    }
  }

  useEffect(() => {
    if (isValidEmail && isMatchingEmail && nameEntered && isValidNumberOfChildren && !timeslotClash && !isFirstRender) {
      setBasketOpen(true)
      setDetailsEntered(true)
      lockTimeslot()
    }

    if (isFirstRender) {
      setIsFirstRender(false)
    }

    // eslint-disable-next-line
  }, [continueClicked])

  return (
    <div className='details-section'>
      <p>Please fill out the following form</p>
      <p>Name:</p>
      <input value={customerName} onChange={e => setCustomerName(e.target.value)} />
      {!nameEntered && !isFirstRender &&
        <p className='errorMessage'>Please enter your name</p>
      }
      <p>Number of Children:</p>
      <input type='number' min='1' max='4' value={numberOfChildren} onChange={e => setNumberOfChildren(e.target.value)} />
      {!isValidNumberOfChildren && !isFirstRender &&
        <p className='errorMessage'>Please choose between 1 and 4 children</p>
      }
      <p>Email Address:</p>
      <input type='email' value={customerEmail} onChange={e => setCustomerEmail(e.target.value)} />
      {!isValidEmail && !isFirstRender &&
        <p className='errorMessage'>Please enter your email address</p>
      }
      <p>Repeat Email Address:</p>
      <input type='email' value={customerRepeatEmail} onChange={e => setCustomerRepeatEmail(e.target.value)} />
      {!isMatchingEmail && !isFirstRender &&
        <p className='errorMessage'>Please ensure your email address is correct</p>
      }
      {!timeslotClash &&
        <div>
          <button onClick={e => continueToPayment()}>Continue to Payment</button>
        </div>
      }
      {timeslotClash &&
        <div>
          <button onClick={e => window.location.reload()}>Start Over</button>
        </div>
      }
      {timeslotClash &&
        <p className='errorMessage'>Unfortunately, during the booking process this timeslot has been taken by another user.</p>
      }
    </div>
  )
}

export default EnterDetails